import { AvatarPerson } from '../models/avatar-person.model';

/**
 * The full name of a person, from whichever field their reference carries it in.
 *
 * @param {AvatarPerson | null | undefined} person - The person, if any
 * @returns {string} Their name, or an empty string where none is known
 */
export function resolvePersonName(person: AvatarPerson | null | undefined): string {
  if (!person) {
    return '';
  }
  return person.label?.trim() || person.name?.trim() || [person.vorname, person.nachname].filter(Boolean).join(' ');
}
